/** Admin product list table — column visibility (localStorage). */

export type ProductListColumnId =
    | 'index'
    | 'name'
    | 'provider'
    | 'price'
    | 'clubPrice'
    | 'salePrice'
    | 'saleUntil'
    | 'deliveryCost'
    | 'size'
    | 'count'
    | 'stockLink'
    | 'importCost'
    | 'deliveryDayMargin'
    | 'barCode'
    | 'slugLink'
    | 'active'
    | 'actions';

export type ProductListColumnVisibility = Record<ProductListColumnId, boolean>;

export const PRODUCT_LIST_TABLE_COLUMNS: { id: ProductListColumnId; label: string }[] = [
    { id: 'index', label: '№' },
    { id: 'name', label: 'Нэр' },
    { id: 'provider', label: 'Нийлүүлэгч' },
    { id: 'price', label: 'Үнэ' },
    { id: 'clubPrice', label: 'Клубын үнэ' },
    { id: 'salePrice', label: 'Хямдралтай үнэ' },
    { id: 'saleUntil', label: 'Хямдралын сүүлийн өдөр' },
    { id: 'deliveryCost', label: 'Хүргэлтийн зардал' },
    { id: 'size', label: 'Хэмжээ' },
    { id: 'count', label: 'Үлдэгдэл' },
    { id: 'stockLink', label: 'Үлдэгдэл засах' },
    { id: 'importCost', label: 'Өртөг тооцдог' },
    { id: 'deliveryDayMargin', label: 'Хүргэх өдөр' },
    { id: 'barCode', label: 'Бар код' },
    { id: 'slugLink', label: 'Линк' },
    { id: 'active', label: 'Идэвхитэй' },
    { id: 'actions', label: 'Устгах' },
];

const STORAGE_KEY = 'chef.admin.products.tableColumnVisibility';

function defaultVisibility(): ProductListColumnVisibility {
    const out = {} as ProductListColumnVisibility;
    for (const c of PRODUCT_LIST_TABLE_COLUMNS) {
        out[c.id] = true;
    }
    return out;
}

export function loadProductListColumnVisibility(): ProductListColumnVisibility {
    const defaults = defaultVisibility();
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return defaults;
        const parsed = JSON.parse(raw) as unknown;
        if (parsed == null || typeof parsed !== 'object' || Array.isArray(parsed)) return defaults;
        const o = parsed as Record<string, unknown>;
        const out = { ...defaults };
        for (const c of PRODUCT_LIST_TABLE_COLUMNS) {
            if (typeof o[c.id] === 'boolean') {
                out[c.id] = o[c.id] as boolean;
            }
        }
        return out;
    } catch {
        return defaults;
    }
}

export function saveProductListColumnVisibility(v: ProductListColumnVisibility): void {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(v));
    } catch {
        /* ignore quota / private mode */
    }
}
